<template>
  <el-form class="repair-done" label-width="120px">
    <el-form-item label="审核结果">
      <el-switch
        v-model="form.verifyType"
        active-text="通过"
        inactive-text="拒绝"
      ></el-switch>
    </el-form-item>
    <el-form-item label="备注">
      <el-input type="textarea" v-model="form.description"
       placeholder="请输入备注"></el-input>
    </el-form-item>
    <el-form-item >
      <el-button size="small" type="primary" @click="onSubmit">确认</el-button>
      <el-button size="small" @click="onCancel">取消</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import { getNextStepInfo, auditOrder, uploadImages } from '@/api/equipment-operational/index';
import { convertDataToFormData } from '@/utils/utils';
import DiaFormMixin from '@/components/operating-maintenance/mixins/dia-form-mixin';

export default {
  name: 'arrive-sence',
  mixins: [DiaFormMixin],
  props: {
    selectProcessInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      form: {
        taskId: null,
        verifyType: true,
        nextstep: '',
        auditers: {},
        // 修复信息
        description: '',
        // 客户反馈信息
        CustomerFeedback: '',
        fileData: '',
      },
      nextStepList: [],
    };
  },
  created() {
    this.initialFormData();
    this.requestNextStepList();
  },
  watch: {
    selectProcessInfo() {
      this.initialFormData();
      this.requestNextStepList();
    },
  },
  methods: {
    // 初始化表单数据
    initialFormData() {
      this.form.taskId = this.selectProcessInfo.F_TaskId;
    },
    // 提交申请
    onSubmit() {
      this.submitAudit();
    },
    // 取消申请
    onCancel() {
      this.emitCloseDialog();
    },
    // 提交审核
    submitAudit() {
      this.formatForm();
      const formData = convertDataToFormData(this.form);
      auditOrder(formData).then(() => {
        this.notifyDataChanged();
        this.emitCloseDialog();
      });
    },
    formatForm() {
      const repairData = {
        reviewContent: this.form.description,
      };
      this.form.formData = JSON.stringify(repairData);
      const auditers = [{}];
      this.form.auditers = JSON.stringify(auditers);
      // 审核结果 转换 （1、通过；2、拒绝）
      if (this.form.verifyType) {
        this.form.verifyType = 1;
      } else {
        this.form.verifyType = 2;
        this.clearUploadImgList();// 审核驳回时 需先清空之前上传的图片
      }
    },
    // 清除之前上传的图片
    clearUploadImgList() {
      const params = {
        processId: this.selectProcessInfo.F_Id, // 工单id
        verifyType: this.form.verifyType, // 当前审核状态
        Type: this.selectProcessInfo.F_SchemeCode.replace('GD', ''), // 工单类型
      };
      uploadImages({}, params).then(() => {
        // console.log('清除图片成功');
      });
    },
    requestNextStepList() {
      if (this.selectProcessInfo == null) {
        return;
      }
      getNextStepInfo({
        isNew: false,
        processId: this.selectProcessInfo.F_Id,
        schemeCode: this.selectProcessInfo.F_SchemeCode,
        taskId: this.selectProcessInfo.F_TaskId,
        formData: '',
      }).then((res) => {
        this.nextStepList = res;
        const [nextStep] = res;
        this.form.nextstep = nextStep.id;
        this.form.auditers = [{
          [nextStep.nodeId]: {
            userId: nextStep.id,
            userName: nextStep.text,
          },
        }];
      });
    },
  },
};
</script>
